module.exports = __webpack_public_path__ + "img/202010_review.7169dc5b.jpg";